import React, { FC, HTMLAttributes } from 'react';
import styles from './styles.module.scss';

interface FormGroupProps extends HTMLAttributes<HTMLDivElement> {
    label?: string,
    required?: boolean,
}

const FormGroup: FC<FormGroupProps> = ({ children, className, label, required, ...props }): JSX.Element => {
    return (
        <div
            className={[
                styles.group,
                className,
            ].join(' ')}
            {...props}
        >
            {label && <label className={styles.label}>
                {label}
                {required && <span>*</span>}
            </label>}
            {children}
        </div>
    )
}

export default FormGroup;
